module.exports = __webpack_public_path__ + "static/media/Ubiquiti.f243f33b.jpg";